import { render, staticRenderFns } from "./llamarViejitos.vue?vue&type=template&id=7ac26859"
import script from "./llamarViejitos.vue?vue&type=script&lang=js"
export * from "./llamarViejitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports